import * as React from 'react';
import * as _ from 'lodash';
import { Link } from 'react-router';
import { parseSubscriberAction } from './';
import keyUpHandler from '../../utils/keyUpHandler';
import SubscribeDialogCTA from '../../App/SubscribeDialogCTA';
export default function () {
    function onClick1(props, withClick, hasBtn) {
        props.btn.action();
    }
    function onKeyUp2(props, withClick, hasBtn, event) {
        keyUpHandler(event, this.props.onClick);
    }
    function scopePropsWithClickHasBtn3() {
        var props = this.props;
        var withClick = this.props.onClick;
        var hasBtn = !_.isEmpty(this.props.btn);
        return React.createElement('div', { 'className': 'FeaturedElement' }, React.createElement('div', {
            'className': 'photo',
            'style': { backgroundImage: 'url(\'' + props.photo.original + '\')' }
        }, React.createElement('div', { 'className': 'gradient' })), React.createElement('div', { 'className': 'headline' }, props.categoryLinkTo ? React.createElement(Link, {
            'to': props.categoryLinkTo,
            'className': 'category',
            'key': '586'
        }, props.categoryName) : null, React.createElement('div', { 'className': 'title-container' }, React.createElement('h1', { 'className': 'title' }, props.title), React.createElement('div', { 'className': 'separator' }), React.createElement('h2', { 'className': 'artist' }, props.artist)), hasBtn && props.btn.text !== 'Subscribe to Watch' && typeof props.btn.action !== 'function' ? React.createElement(Link, {
            'className': this.props.btn.class ? this.props.btn.class : 'read-on btn -thin -blue-2 no-margin',
            'to': parseSubscriberAction(props.btn.action),
            'key': '918'
        }, '\n      ', props.btn.text, '\n    ') : null, hasBtn && props.btn.text === 'Subscribe to Watch' && typeof props.btn.action !== 'function' ? [
            React.createElement(SubscribeDialogCTA, { 'key': '12621' }, React.createElement('div', { 'className': 'subscribe-to-watch-btn' }, React.createElement('span', {}, props.btn.text))),
            !props.usedFreeTrial ? React.createElement('span', {
                'className': 'add-to-cart-msg',
                'key': '12623'
            }, '\n        Free 7-Day Trial\n      ') : null
        ] : null, hasBtn && typeof props.btn.action === 'function' ? React.createElement('span', {
            'className': this.props.btn.class ? this.props.btn.class : 'read-on btn -thin -blue-2 no-margin',
            'onClick': onClick1.bind(this, props, withClick, hasBtn),
            'key': '1695'
        }, '\n        ', props.btn.text, '\n    ') : null, withClick ? React.createElement('div', {
            'aria-labelledby': 'preview-label',
            'className': 'overlay',
            'onClick': () => this.props.onClick(),
            'onKeyUp': onKeyUp2.bind(this, props, withClick, hasBtn),
            'tabIndex': '0',
            'key': '1953'
        }, React.createElement('i', { 'className': 'icon-play' }), React.createElement('span', {
            'id': 'preview-label',
            'className': 'preview'
        }, 'Trailer')) : null, props.extraHTML ? React.createElement('div', {
            'className': 'extra-html',
            'dangerouslySetInnerHTML': { __html: props.extraHTML },
            'key': '2287'
        }) : null));
    }
    return scopePropsWithClickHasBtn3.apply(this, []);
}